import React from "react";

const Banner = () => {
    return (
        <div className="w-full">
            <img
                src="//cdn.shopify.com/s/files/1/1903/4853/files/slideshow3-home2_1920x.jpg?v=1613166679"
                alt="banner"
                className="h-[438px] max-md:h-[300px] w-full object-cover"
            />
        </div>
    );
};

export default Banner;
